import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Alert } from 'reactstrap'
import moment from 'moment'
import AutoTable from 'components/AutoTable'
import { SiteColContainer } from './SitesGrid.styles'
import { IsRosteredBadge } from '../../../../components/IsRosteredBadge/IsRosteredBadge'

class SitesGrid extends Component {
  static propTypes = {
    licenses: PropTypes.arrayOf(PropTypes.object).isRequired,
  }
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      confirmShow: false,
      onConfirm: null,
      confirmTitle: '',
      confirmBody: null,
    }
  }

  columns = [
    {
      title: 'Site Name',
      fieldValue: 'name',
    },
    {
      title: 'Site Id',
      fieldValue: row => {
        return (
          <SiteColContainer>
            <Link to={`/css-admin/sites/${row.id}`}>
              {row.id}
            </Link>
            <IsRosteredBadge isRostered={row.isRostered} />
          </SiteColContainer>
        )
      },
      sortValue: 'id',
      filterValue: 'id',
    },
    {
      title: 'Organization Id',
      fieldValue: 'organizationId',
    }
  ]

  render = () => {
    const { licenses } = this.props

    return licenses && licenses.length ? (
      <AutoTable
        borderless
        columns={this.columns}
        filter
        headThemeLight
        rows={licenses}
        sort
      />
    ) : (
      <Alert color="warning">No results found</Alert>
    )
  }
}

export default SitesGrid



// WEBPACK FOOTER //
// ./src/containers/css-admin/users/SitesGrid/SitesGrid.js